import {GoogleApiInterface} from '@/config/googleMap'

export default {
  // 住所検索
  searchAddress (config = {}) {
    return GoogleApiInterface.get('', config).then(res => {
      return res.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/xhr/xhr-googlemap.js